<template>
  <div class="mobile-app-tiles-item">
    <div class="mobile-app-tiles-item__content">
      <img :src="image" alt="tile-icon" class="tile-image" />
      <div class="tile-title">
        {{ title }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MobileAppTilesItem",
  props: {
    title: {
      type: String,
      required: true,
    },
    image: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped lang="less">
@import "@/styles/_mixins";

.mobile-app-tiles-item {
  &__content {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: start;
    background: linear-gradient(
      180deg,
      #313944 0%,
      rgba(49, 57, 68, 0) 128.66%
    );
    opacity: 0.8;
    border: 1px solid rgba(255, 255, 255, 0.08);
    backdrop-filter: blur(30px);
    border-radius: 15px;
    padding: 20px 15px;

    .tile-image {
      width: 50px;
      height: 50px;
      border-radius: 10px;
      margin-bottom: 10px;
    }

    .tile-title {
      font-style: normal;
      font-weight: 700;
      font-size: 17px;
      line-height: 19px;
      color: #ffffff;
      text-align: left;
    }
  }
}
</style>
